// 路由信息，纯JS对象，方便读取路由信息
import { ERouterName } from './config';
import Home from './views/home/home.vue';
import Coupon from './views/coupon/index.vue';
import ThirdMpRedirect from './views/third-mp/index.vue';

export default {
  routes: [
    {
      path: '/coupon',
      name: ERouterName.coupon,
      component: Coupon,
      cname: '单张券页',
    },
    {
      path: '/thirdmpredirect',
      name: ERouterName.thirdmpredirect,
      component: ThirdMpRedirect,
      cname: '第三方小程序中转页',
    },
    {
      path: '/',
      name: ERouterName.home,
      component: Home,
      cname: '首页',
    },
    {
      path: '*',
      name: ERouterName.home,
      component: Home,
      cname: '首页',
    },
  ],
};
